export const EwayBillErrorMessages = {
    ERROR_WHILE_GENERATING_PDF: "Error occurred while generating PDF sheet",
    ERROR_WHILE_FETCHING_LMVRID: "Error occurred while fetching LM-VRID details for the station",
    ERROR_WHILE_FETCHING_EWAYBILL: "Error occurred while fetching E-way Bills",
    DEFAULT: "Server Error"
}

export const csvFileName = "LM_VRIDDetails.csv"


// WEBPACK FOOTER //
// ./src/components/eWayBill/constants/EwayBillErrorMessages.js